import { Flex } from '@grupoboticario/flora-react';

import { ResponsiveFloraTypography } from 'components';
import config from 'config';
import { useResellerDetail } from 'hooks';

import { useLoyaltyIncentiveCampaign } from '../../hooks/useLoyaltyIncentiveCampaign';

export const Description = () => {
  const { data, isOptinClosed } = useLoyaltyIncentiveCampaign();
  const { data: resellerDetail } = useResellerDetail();
  const isLoyaltyMember = resellerDetail?.reseller.isLoyaltyMember ?? false;
  let descriptionMessage = (
    <>
      {`Os TOP ${data?.limit} ${config.communication.userNamingConvention.plural} de cada faixa dos programas de fidelidade poderão ganhar 1 bolsa exclusiva e até R$ 1.000 em produtos! Além da bolsa exclusiva do incentivo, os TOP VIPs (rubi, esmeralda e diamante), concorrem a 1 viagem para Bahia com visita à fábrica do Grupo Boticário em Camaçari. Saiba mais e confira vagas por faixa no regulamento do incentivo.`}
      <br />
      <br />
      {`E mais: participe dos desafios, acumule pontos e multiplique suas chances de conquistar recompensas incríveis.`}
      <br />
      <br />
      {`São duas formas de ganhar, descubra como aproveitar:`}
    </>
  );

  if (isLoyaltyMember) {
    descriptionMessage = (
      <>
        {`Os TOP ${data?.limit} ${config.communication.userNamingConvention.plural} de cada faixa dos programas de fidelidade poderão ganhar 1 bolsa exclusiva e até R$ 1.000 em produtos! Além da bolsa exclusiva do incentivo, os TOP VIPs (rubi, esmeralda e diamante), concorrem a 1 viagem para Bahia com visita à fábrica do Grupo Boticário em Camaçari. Saiba mais e confira vagas por faixa no regulamento do incentivo.`}
        <br />
        <br />
        {`Descubra como aproveitar:`}
      </>
    );
  }

  if (isOptinClosed) {
    if (isLoyaltyMember) {
      descriptionMessage = (
        <>
          {`Durante o período da campanha, os TOP ${data?.limit} ${config.communication.userNamingConvention.plural} que se cadastraram e investiram em estojos de Dia das Mães, itens de maquiagem e produtos da categoria facial garantiram prêmios.`}
        </>
      );
    } else {
      descriptionMessage = (
        <>
          {`Durante o período da campanha, os TOP ${data?.limit} ${config.communication.userNamingConvention.plural} que se cadastraram e investiram em estojos de Dia das Mães, itens de maquiagem e produtos da categoria facial garantiram prêmios. Foram duas mecânicas que dobraram as chances de conquistas e vantagens!`}
        </>
      );
    }
  }

  return (
    <Flex direction='column' gap='$6'>
      <ResponsiveFloraTypography fontSize='title' fontWeight='bold' as='h2'>
        {isOptinClosed ? 'Como funcionou' : 'Como participar'}
      </ResponsiveFloraTypography>

      <Flex direction='column' gap='$4'>
        <ResponsiveFloraTypography color='$nonInteractivePredominant'>
          {descriptionMessage}
        </ResponsiveFloraTypography>
      </Flex>
    </Flex>
  );
};
